import { render, staticRenderFns } from "./flowModal.vue?vue&type=template&id=84bfdb6e&scoped=true&"
import script from "./flowModal.vue?vue&type=script&lang=js&"
export * from "./flowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bfdb6e",
  null
  
)

export default component.exports